const start = 0;
const perPage = 25;
const order = 'ASC';

export { start, perPage, order };
